import { reduxForm } from 'redux-form';
import validateTool from 'validate.js';
import BingoVotingForm from './BingoVotingForm';
import { convertDate, parseVotingStatuses } from '../helper';
import BingoVoting from '../../../../../api/voting/bingo';
import { TYPE_BINGO } from '../../../../../api/voting/base';
import EventActions from '../../../../../actions/event';

const validate = (data) => {
  return validateTool(data, BingoVoting.validateConstraints) || {};
};

const fields = [
  'voting',
  'file',
  'award_location',
  'start_time',
  'end_time',
  'game_description',
];

export default reduxForm(
  {
    form: 'bingo_voting',
    fields,
    returnRejectedSubmitPromise: true,
    validate,
  },
  (state) => {
    let { event } = state;
    let voting = event.model.bingoVoting || new BingoVoting();

    let data = parseVotingStatuses(voting);
    Object.assign(data, {
      initialValues: prepareBingoVoting(voting)
    });

    return data;
  },
  (dispatch) => ({
    announceResult: (data) => dispatch(EventActions.announceResultVoting(TYPE_BINGO, data)),
    save: (data) => dispatch(EventActions.saveVoting(TYPE_BINGO, data)),
    publish: (data) => dispatch(EventActions.publishVoting(TYPE_BINGO, data))
  })
)(BingoVotingForm);

function prepareBingoVoting(bingo) {
  if ( bingo ) {
    return {
      award_location: bingo.award_location,
      game_description: bingo.game_description,
      file: bingo.award_image || bingo.file,
      start_time: convertDate(bingo.start_time),
      end_time: convertDate(bingo.end_time)
    };
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/BingoVoting/index.js